module.exports = __webpack_public_path__ + "img/7.ef988c00.jpg";